import React, { useState } from "react";
import * as moment from "moment";
import VideoPlayer from "components/VideoPlayer";
import AudioPlayer from "components/AudioPlayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { useExpressionsContext } from "store/contexts/expressionsContext";
import TeamService from "services/TeamService";
import UserDefaultAvatar from "assets/img/user.svg";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useTeamContext } from "store/contexts/teamContext";
import { useHistory } from "react-router-dom";
import Linkify from "react-linkify";
import MediaPreview from "components/MediaPreview/MediaPreview";
import DocumentPreview from "components/DocumentPreview";
import LazyLoadImage from "components/LazyLoadImage";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import CommentFooter from "./CommentFooter";

var styles = {
  mediaComment: {
    padding: "10px",
    flex: 1,
    border: "none",
  },
  commentImage: {
    maxWidth: "300px",
    width: "100%",
    maxHeight: "300px",
    objectFit: "contain",
  },
  mediaContent: {
    fontSize: "0.875rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.43,
    paddingTop: "8px",
  },
  documentContent: {
    fontSize: "0.875rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.43,
    paddingTop: "8px",
    paddingBottom: "10px",
  },
  commentVideo: {
    maxWidth: "400px",
  },
  playMessage: {
    position: "absolute",
    top: 0,
    left: 0,
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "59%",
    alignItems: "center",
    height: "100%",
  },
  playIcon: {
    cursor: "pointer",
    "&:hover": {
      opacity: "0.8",
    },
  },
  cancelAudio: {
    backgroundColor: "#1e232c",
    display: "flex",
    justifyContent: "flex-end",
    color: "white",
    padding: "5px",
  },
};

export default ({ expression, post }) => {
  let history = useHistory();
  const classes = styles;
  const [showAudio, setShowAudio] = useState(false);
  const { team } = useTeamContext();
  const { teamId } = useTeamActionContext();
  const { addToast } = useToasts();
  const { deleteExpression } = useExpressionsContext();
  const [timeDifference] = useState(moment(expression.created_at).fromNow());

  const deleteMyExpression = async () => {
    try {
      await TeamService.deletePostExpression(
        teamId,
        expression.team_post_id,
        expression.id
      );

      deleteExpression(expression);
      addToast("your comment is deleted ", { appearance: "success" });
    } catch (e) {
      console.log(e);
    }
  };

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <div className="user-comments mt-3">
      <img
        onClick={() => showUserProfile(expression?.user?.id)}
        style={{ cursor: "pointer" }}
        className="user-img-comment mw-40"
        src={expression?.user?.avatar ?? UserDefaultAvatar}
        alt={`${expression?.user?.avatar}`}
      />
      <div className="p-user-comment">
        <span className="p-username ff-montserat fw-600 fs-12">
          {expression?.user?.full_name}
        </span>
        <small className="p-comment-time pl-10 fs-12">
          Posted {timeDifference}
        </small>
        {expression?.media_type === "text" && (
          <Linkify
            properties={{
              target: "_blank",
              style: { color: "red", fontWeight: "bold" },
            }}
          >
            <p className="p-comment-content">{expression?.content}</p>
          </Linkify>
        )}
        {expression?.media_type === "document" && (
          <>
            <DocumentPreview expression={expression} />
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div
                style={classes.documentContent}
                className="p-comment-content"
              >
                {expression?.content}
              </div>
            </Linkify>
          </>
        )}
        {expression?.media_type === "video" && (
          <div style={classes.mediaComment}>
            <div style={classes.commentVideo}>
              <VideoPlayer
                src={expression.media}
                mediaCaptions={expression?.media_captions?.vtt}
              />
            </div>
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div style={classes.mediaContent} className="p-comment-content">
                {expression?.content}
              </div>
            </Linkify>
          </div>
        )}
        {expression?.media_type === "photo" && (
          <div style={classes.mediaComment}>
            <MediaPreview
              attachment={expression?.media}
              type={"image"}
            >
              <LazyLoadImage
                image={expression?.media}
                style={classes.commentImage}
                alt={`${expression?.media_type}`}
                key={`${expression?.media_type}`}
              />
            </MediaPreview>
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div style={classes.mediaContent} className="p-comment-content">
                {expression?.content}
              </div>
            </Linkify>
          </div>
        )}
        {expression?.media_type === "audio" && !showAudio && (
          <div style={classes.mediaComment}>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  backgroundColor: "black",
                  width: "100%",
                  maxWidth: "400px",
                  height: "200px",
                }}
              ></div>
              <div style={classes.playMessage}>
                <span>Click to play the audio</span>
                <FontAwesomeIcon
                  onClick={() => setShowAudio(true)}
                  icon={faPlayCircle}
                  style={classes.playIcon}
                />
              </div>
            </div>
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div style={classes.mediaContent} className="p-comment-content">
                {expression?.content}
              </div>
            </Linkify>
          </div>
        )}
        {showAudio && (
          <div style={{ paddingBottom: "15px" }}>
            <div style={classes.cancelAudio}>
              <CancelIcon
                style={{ cursor: "pointer", width: "18px", height: "18px" }}
                onClick={() => setShowAudio(false)}
              />
            </div>
            <AudioPlayer autoplay={true} src={expression.media} />
            <div style={classes.mediaContent} className="p-comment-content">
              {expression?.content}
            </div>
          </div>
        )}
        <CommentFooter
          post={post}
          expression={expression}
          teamRole={team?.role_id}
          deleteMyExpression={deleteMyExpression}
        />
      </div>
    </div>
  );
};
